import * as React from 'react';
import MyTypes from 'MyTypes';
import { connect, ConnectedProps } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';
import { Modal, Button, Form, Row, Col } from 'react-bootstrap'; 
import * as models from '../../models';
import * as companyActions from '../../store/companies/actions';
import _ from 'lodash'; 

interface Props extends PropsFromRedux {          
    closeModal: () => void;
    showModal: boolean;
    editingType: models.CompanyFileType | null; 
}

interface State {
    fileType: models.CompanyFileType;
}

const defaultFileType: models.CompanyFileType = {
    id: 0,
    name: '',
    description: '',
    isActive: true,
    createdDate: new Date().toISOString(),
    createdBy: ''
};

class CompanyFileTypeModal extends React.Component<Props, State> {
    public state: State = {
        fileType: this.props.editingType || { ...defaultFileType }
    };

    componentDidUpdate(prevProps: Props) {
        if ((!prevProps.showModal && this.props.showModal) || 
            (!_.isEqual(prevProps.editingType, this.props.editingType))) {
            this.setState({ 
                fileType: this.props.editingType ? { ...this.props.editingType } : { ...defaultFileType } 
            });
        }
    }

    public resetFormAndClose = () => {
        this.setState({ fileType: { ...defaultFileType } }, () => {
            this.props.closeModal();
        });
    }

    public submitForm = (e: React.FormEvent) => {
        e.preventDefault();
        const { fileType } = this.state;

        if (fileType.id > 0) {
            this.props.updateCompanyFileType(fileType);
        } else {
            // Passing the AddCompanyFileType object (name and description)
            const newType: models.AddCompanyFileType = {
                name: fileType.name,
                description: fileType.description
            };
            this.props.addCompanyFileType(newType);
        }
        
        this.resetFormAndClose();
    }

    public render() {
        const { showModal } = this.props;
        const { fileType } = this.state;
        const isNew = fileType.id === 0;

        return (
            <Modal 
                centered={true} 
                show={showModal} 
                onHide={this.resetFormAndClose}
                onExited={() => this.setState({ fileType: { ...defaultFileType } })}
            >
                <Modal.Header closeButton>
                    <Modal.Title>{isNew ? "Add" : "Edit"} Company File Type</Modal.Title>
                </Modal.Header>                
                <Form className="claim-modal" onSubmit={this.submitForm}>                    
                    <Modal.Body>  
                        <Form.Group as={Row} controlId="typeName" className="input-field-container">
                            <Form.Label column sm="4">Type Name</Form.Label>
                            <Col sm="8">
                                <Form.Control 
                                    type="text"
                                    placeholder="e.g. Review Rules"
                                    value={fileType.name}
                                    required
                                    autoFocus
                                    onChange={(e) => this.setState({ fileType: { ...fileType, name: e.target.value } })}
                                />
                            </Col>
                        </Form.Group>

                        {/* New Description Field */}
                        <Form.Group as={Row} controlId="description" className="input-field-container">
                            <Form.Label column sm="4">Description</Form.Label>
                            <Col sm="8">
                                <Form.Control 
                                    as="textarea"
                                    rows={3}
                                    placeholder="Briefly describe what this file type is for..."
                                    value={fileType.description || ''}
                                    onChange={(e) => this.setState({ fileType: { ...fileType, description: e.target.value } })}
                                />
                            </Col>
                        </Form.Group>

                        {!isNew && (
                            <Form.Group as={Row} controlId="isActive" className="input-field-container">
                                <Form.Label column sm="4">Active Status</Form.Label>
                                <Col sm="8" className="d-flex align-items-center">
                                    <Form.Check 
                                        type="switch"
                                        id="active-switch"
                                        label={fileType.isActive ? "Active" : "Inactive"}
                                        checked={fileType.isActive}
                                        onChange={(e) => this.setState({ fileType: { ...fileType, isActive: e.target.checked } })}
                                    />
                                </Col>
                            </Form.Group>
                        )}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={this.resetFormAndClose}>
                            CANCEL
                        </Button>
                        <Button variant="primary" type="submit">
                            {isNew ? "CREATE" : "UPDATE"}
                        </Button>
                    </Modal.Footer>
                </Form>
            </Modal>
        );
    }
}

const mapStateToProps = (state: MyTypes.RootState) => ({});

const mapDispatchToProps = (dispatch: Dispatch) =>
    bindActionCreators(
        {
            addCompanyFileType: companyActions.addCompanyFileType,
            updateCompanyFileType: companyActions.updateCompanyFileType,
        },
        dispatch
    );

const connector = connect(mapStateToProps, mapDispatchToProps); 
type PropsFromRedux = ConnectedProps<typeof connector>;

export default connector(CompanyFileTypeModal);